





















import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";

@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue"),
    "basket-avatar": () =>
      import("@/components/app/global/baskets/basket/basketAvatar.vue")
  }
})
export default class BasketTopper extends Mixins(Context, ClientMixin) {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly basketProviderData!: () => IBasketProviderData;

  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  public get $basketData() {
    return this.basketProviderData();
  }
}
